export default "__VITE_ASSET__B7C03njT__"